import { configureStore } from '@reduxjs/toolkit';
import * as reducers from './slices';

const store = configureStore({
  reducer: {
    user: reducers.userSlice,
    loader: reducers.loader,
    language: reducers.language,
    call: reducers.call,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      // Ignore non-serializable values (MediaStream objects) in actions and state
      ignoredActions: [
        'call/setLocalStream',
        'call/setLobbyStream',
        'call/addPeer',
        'call/setActiveSpeakerStream',
      ],
      ignoredPaths: [
        'call.localStream',
        'call.lobbyStream',
        'call.peers',
        'call.peers.*.stream', 
        'call.activeSpeakerStream',
        'call.activeSpeakerInfo.stream', 
      ],
    },
  }),
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;

export default store;
